/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const REMOVE_BOUNDING_BOX_FROM_ANNOTATED_IMAGE = gql`
  mutation RemoveBoundingBoxFromAnnotatedImage($imageId: ID!, $boxId: ID!) {
    removeBoundingBoxFromAnnotatedImage(imageId: $imageId, boxId: $boxId) {
      __typename
      ... on RemoveBoundingBoxResult {
        success
        boundingBox {
          id
          sourceImageUrl
          minX
          maxX
          minY
          maxY
          metaClass
          tag
          tagId
          isHumanAdded
          isHumanDeleted
          leasedById
          leasedAt
        }
      }
      ... on OperationInfo {
        messages {
          kind
          message
          field
          code
        }
      }
    }
  }
`
